module.exports = __webpack_public_path__ + "static/college-grad-desktop.513dae84.webp";